<script>

export default {
    props: {
        status: {
            type: Number,
        },
        implementationType: {
            type: Number,
        }
    },
    data() {
        return {
            form: {
                status: this.status,
                type: this.implementationType,
            },
            modalData: {
                show: false,
                updateFields: 0,
            }
        };
    },
    methods: {
        showModal() {
            this.modalData.show = true;
        },
        closeModal() {
            this.modalData.show = false;
        },
        submitModal(updateFields) {
            this.modalData.updateFields = updateFields;
            this.$refs.updateFields.value = updateFields
            this.$refs.platformTableForm.submit();
        }
    }
}
</script>
